






































































import Vue from "vue";
import { Component, Ref } from "vue-property-decorator";

@Component
export default class Signup extends Vue {
  checkEmail = (rule: any, value: any, callback: any) => {
    if (!value) {
      return callback(new Error("Your email address is required"));
    } else {
      // check if the mail is valid
      const regExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!regExp.test(String(value).toLowerCase())) {
        return callback(new Error("Please enter a valid email address"));
      } else {
        this.$store
          .dispatch("authentication/checkEmailExists", this.signupForm.email)
          .then(
            () => {
              return callback();
            },
            () => {
              return callback(new Error("Email already exists"));
            }
          );
      }
    }
  };

  rules: any = {
    email: [
      {
        validator: this.checkEmail,
        required: true,
        trigger: ["submit"],
      },
    ],
  };

  loading = false;
  confirmationEmailSend = false;

  uspList: any = [
    {
      title: "High performance",
      description: "Check thousands of urls within minutes",
    },
    {
      title: "Request headers",
      description: "Add your own headers",
    },
    {
      title: "Export results",
      description: "Customized CSV export of your requests",
    },
  ];

  signupForm: any = {
    email: "",
  };

  @Ref("signupFormRef")
  signupFormRef!: any;

  @Ref("emailInput")
  emailInput!: any;

  mounted() {
    this.emailInput.focus();
  }

  signup() {
    this.signupFormRef.validate((valid: boolean) => {
      if (valid) {
        this.loading = true;
        this.$store
          .dispatch("authentication/signup", this.signupForm.email)
          .then(
            () => {
              this.loading = false;
              this.confirmationEmailSend = true;
              this.signupForm.email = "";
            },
            () => {
              this.loading = false;
              this.$message({
                message:
                  "Something went wrong while submitting your registration. Please try again.",
                type: "error",
              });
            }
          );
      }
    });
  }
}
